import React from 'react';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';

import { remCss, scssVariables, lang } from 'src/helpers';
import { BaseAlert } from './BaseAlert';
import { MCText, View } from '../basic';

import GooglePlayImg from 'src/assets/images/google-play-logo.png';
import AppleImg from 'src/assets/images/apple-logo.png';

export class MobileInfoAlert extends BaseAlert {
  renderMobileAppLinks = () => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

    if (!isMobile) {
      return null;
    }

    return (
      <div
        className={'mc-modal-footer mc-flex-20-col mc-flex-center mc-pt20'}
        style={{ justifyContent: 'center' }}
      >
        <div>
          <MCText
            size={18}
            weight={400}
            label={lang.t('For a better experience Install LifeApp')}
            className={'mc-text-center mc-pb10'}
          />
          <div className={'mc-flex-30'} style={{ justifyContent: 'center', marginTop: 15 }}>
            <a
              className={'mc-no-style-btn'}
              href={'https://play.google.com/apps/test/ai.lifeapp/9'}
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              <img width={remCss(140)} src={GooglePlayImg} alt={'Google Play'} />
            </a>
            <a
              className={'mc-no-style-btn'}
              href={'https://apps.apple.com/'}
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              <img width={remCss(140)} src={AppleImg} alt={'App Store'} />
            </a>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      title,
      close,
      titleTemplate = 'heading',
      iconTemplate = 'primary',
      closeBtn,
      icon = true,
      maxWidth = 340,
      width,
      titleEx,
      isTitleCenter = false
    } = this.props;
    const style = {};
    if (isTitleCenter) {
      style.textAlign = 'center';
    }

    return (
      <div
        className={'mc-popup-contain'}
        style={{ maxWidth: remCss(width || maxWidth), width: '100%' }}
      >
        <div className='mc-modal-header mc-flex-20-col'>
          {icon && (
            <View className={'mc-flex-center'}>
              <SVGIcon
                iconname={GENERAL_ICONS.INFO}
                fill={scssVariables[`colors-mc-${iconTemplate}`]}
              />
            </View>
          )}
          {['string', 'number'].includes(typeof title) ? (
            <MCText
              {...{ [titleTemplate]: true }}
              size={20}
              weight={500}
              label={title}
              style={style}
            />
          ) : (
            title
          )}
          {titleEx}
          {close && closeBtn}
        </div>
        {this.renderBody()}
        {this.renderFooter()}
        {this.renderMobileAppLinks()}
      </div>
    );
  }
}

// http://localhost:4900/patient_signup?code=1%7C7a49f3cb834c0888cf8eba22b89a051e
